// Where to send the browser after sign-in when a `next` parameter is present.
//
// Championship DNA sends a signed-out visitor to /training/login?next=<its own URL>.  `next` is
// followed only when it is (a) a path inside this app, or (b) an https URL on a host that shares this
// host's parent (learn.dev-1.example -> dev-1.example) and points under /week/.  Anything else is
// ignored, so the login page cannot be used as an open redirect.

const DNA_PATH_PREFIX = '/week/';

export function parentHost(hostname) {
  const parts = String(hostname || '').toLowerCase().split('.');
  return parts.length > 2 ? parts.slice(1).join('.') : '';
}

export function safeNext(raw, currentHostname) {
  if (!raw || typeof raw !== 'string') return null;
  if (/^\/(?![/\\])/.test(raw)) return { kind: 'path', value: raw };
  let url;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }
  const parent = parentHost(currentHostname);
  const host = url.hostname.toLowerCase();
  const sameSite = parent && (host === parent || host.endsWith(`.${parent}`));
  if (url.protocol !== 'https:' || url.username || url.password || !sameSite) return null;
  if (!url.pathname.startsWith(DNA_PATH_PREFIX)) return null;
  return { kind: 'url', value: url.toString() };
}

// What the login page should do for an already-signed-in visitor.  A 'url' result is on the MAIN host
// (e.g. https://demo-1.example/week/...), a different origin from this app, so it must be a full-page
// load: handing it to react-router would resolve it against the current (learn.) origin.
export function nextAction(raw, currentHostname) {
  const next = safeNext(raw, currentHostname);
  if (next?.kind === 'url') return { action: 'assign', to: next.value };
  return { action: 'navigate', to: next?.value || '/' };
}
